module.exports = __webpack_public_path__ + "static/media/facebook.f2f66ea8.svg";